import { render, staticRenderFns } from "./BusinessCardsPerStock.vue?vue&type=template&id=fd097ad4&scoped=true&lang=pug&"
import script from "./BusinessCardsPerStock.vue?vue&type=script&lang=js&"
export * from "./BusinessCardsPerStock.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardsPerStock.vue?vue&type=style&index=0&id=fd097ad4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd097ad4",
  null
  
)

/* custom blocks */
import block0 from "./BusinessCardsPerStock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports